import {
  LAST_CHAT_ID_KEY,
  CHAT_BLOCKED_PREFIX,
  CHAT_MODAL_POSITION_KEY,
} from '#app/pages/Chat/constans/chat';

/** Очищает все данные чата в localStorage (вызов при логауте). */
export function clearChatLocalStorage(): void {
  try {
    localStorage.removeItem(LAST_CHAT_ID_KEY);
    localStorage.removeItem(CHAT_MODAL_POSITION_KEY);
    const keysToRemove: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key?.startsWith(CHAT_BLOCKED_PREFIX)) keysToRemove.push(key);
    }
    keysToRemove.forEach((k) => localStorage.removeItem(k));
  } catch {
    // ignore
  }
}
